module.exports = __webpack_public_path__ + "fonts/26a18094f833de22b4e36eb2563eed6d.svg";